import { render } from "./PosterComponent.vue?vue&type=template&id=8cea454c&ts=true"
import script from "./PosterComponent.vue?vue&type=script&lang=ts"
export * from "./PosterComponent.vue?vue&type=script&lang=ts"

import "./PosterComponent.vue?vue&type=style&index=0&id=8cea454c&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__